import { Injectable } from '@angular/core';
import { AppUserHomeRequest } from '../SicorService/RequestObject/AppUserHomeRequest';
import { tap, shareReplay, take } from 'rxjs/operators';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { GlobalVariablesService } from '../global-variables.service';
import { GlobalMethodsService } from '../global-methods.service';
import { NavigationService } from './navigation.service';
import { Codeword } from '../../models/Codeword';
import { CodewordChangeRequest } from '../SicorService/RequestObject/CodewordChangeRequest';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { ModalController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProtocolService {

  constructor(private sicorAPI: SicorApiService,
    public gvs: GlobalVariablesService,
    private translate: TranslateConfigService,
    public gms: GlobalMethodsService,
    public modalCtrl: ModalController,
    private navigation: NavigationService) { }

  public async getInstallationCodewords(requestParams: AppUserHomeRequest): Promise<Codeword[]>  {
    let codewordsList: Codeword[] = [];
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.requestInstallationCodewords(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(false, '', 'protocolModal');
                this.modalCtrl.dismiss(false, '', 'loadSpinner');
                resolve(null);
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                codewordsList = res.resultSet;
                resolve(codewordsList);
              }
            } else {
              resolve(null);
            }
          }, error: async e => {
            resolve(null);
            await this.gms.openFailedProcessModal();
            await this.navigation.goHome();
          }
        })
      ));
    });
  }

  public async changeInstallationCodewords(requestParams: CodewordChangeRequest): Promise<any> {
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.requestInstallationCodewordsChange(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet[0] != null && res.resultSet[0].error != null) {
              if (res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(null, '', 'protocolModal');
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
                resolve(res.resultSet[0].error);
              }
              else if (res.resultSet[0].error === 301) {
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), res.resultSet[0].messages,
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
                resolve(res.resultSet[0].error);
              }
            }
            else if (res.debug != null && res.debug.Table1 != null && res.debug.Table1[0] != null && res.debug.Table1[0].error != null) {
              resolve(res.debug.Table1[0].error);
            } else {
            resolve(null);
            }
          }, error: e => {
            resolve(null);
          }
        })
      ));
    });
  }
}
